import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";
import { ModosOp, DialogType } from "../../../isp._comun/iu/_principal/constantesIuPrin";
import getEstadoInicial from "../EstadoDialogoServicio";

export default class VentanaServicio extends Ventana {
    constructor(estadoComp) {
        super();
        this.id= DialogType.SERVICIO+estadoComp.domain.screen.idCliente;
        this.estadoComp = estadoComp;
        // super();
        // this.estadoComp = getEstadoInicial();
        /* this.estadoCom = {
            domain: {
                screen: {
                    idCliente: null,
                },
            },
            flag: {
                modoOperacion: ModosOp.CREAR,
                modal: false,
                cargandoEntidad: false,
            },
        }; */
        // this.dispatch = null;
        // this.ventanaCargando=null
    }

    static nuevaVentanaEnModoCrear() {
        return new VentanaServicio(getEstadoInicial());
    }

    static nuevaVentanaEnModoOk(idCliente) {
        const estadoComp = getEstadoInicial();
        estadoComp.flag.modoOperacion = ModosOp.OK;
        estadoComp.domain.screen.idCliente = idCliente;
        estadoComp.flag.modal = true;
        estadoComp.flag.cargandoEntidad = true;
        return new VentanaServicio(estadoComp);
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaServicio)) {
            return false;
        }

        if(this.id === ventanaAAbrir.id){
            return true;
        }

        return false;

        /* 
        if (
            this.estadoComp.flag.modoOperacion === ModosOp.CREAR &&
            ventanaAAbrir.estadoComp.flag.modoOperacion === ModosOp.CREAR
        ) {
            return true;
        }

        if (
            this.estadoComp.flag.modoOperacion !== ModosOp.CREAR &&
            ventanaAAbrir.estadoComp.flag.modoOperacion !== ModosOp.CREAR &&
            this.estadoComp.domain.screen.idCliente ===
                ventanaAAbrir.estadoComp.domain.screen.idCliente
        ) {
            return true;
        }

        return false; */
    }

    clonar() {
        const nuevaVentana = new VentanaServicio(this.estadoComp);
        // nuevaVentana.id = this.id;
        nuevaVentana.posicionZ = this.posicionZ;
        // nuevaVentana.estadoComp = this.estadoComp;
        // nuevaVentana.dispatch = this.dispatch;
        // nuevaVentana.ventanaCargando = this.ventanaCargando
        return nuevaVentana;
    }
}
